import { useQuery } from '@tanstack/react-query'
import { useDI } from '@/di/DIContext'
import type { AgentId } from '@/domain/shared/Brand'

export function useLast7DaysEarnings() {
  const { performanceService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  const query = useQuery({
    queryKey: ['last7DaysPerformance', agentId],
    queryFn: () =>
      performanceService.getLast7DaysPerformance(agentId as AgentId),
    enabled: !!agentId,
    gcTime: 0,
    staleTime: 0,
    retry: false,
  })

  return {
    ...query,
    refetchByInvalidation: () => query.refetch(),
  }
}
